import React from 'react';

import {
    Card,
    CardContent,
    CardHeader,
    Divider, Grid,
    Table, TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';

const Addr = ({addr}) => {
    return <Grid container direction="row">
        <Grid item>
            {addr.family} {addr.family} {addr.local}/{addr.prefixlen}
        </Grid>
    </Grid>;
};

const Device = ({dev}) => {
    return <TableRow>
        <TableCell align="left">{dev.ifname}</TableCell>
        <TableCell align="left">{dev.link_type}</TableCell>
        <TableCell align="left">{dev.operstate}</TableCell>
        <TableCell align="left">{dev.addr_info.map((addr, idx) => <Addr addr={addr} key={idx}/>)}</TableCell>
    </TableRow>;
};

const Devices = ({data}) => {
    if (!Array.isArray(data)) {
        return null;
    }

    return <Table sx={{minWidth: 650}} size="small">
        <TableHead>
            <TableRow>
                <TableCell align="center" sx={{fontWeight: '600'}} width={150}>Interface</TableCell>
                <TableCell align="center" sx={{fontWeight: '600'}} width={100}>Link type</TableCell>
                <TableCell align="center" sx={{fontWeight: '600'}} width={110}>State</TableCell>
                <TableCell align="center" sx={{fontWeight: '600'}}>Addresses</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {data.map(dev => <Device key={dev.ifindex} dev={dev}/>)}
        </TableBody>
    </Table>;
};

const NetDevs = ({data}) => {
    return <Card>
        <CardHeader title="Devices"/>
        <Divider/>
        <CardContent>
            <Devices data={data}/>
        </CardContent>
    </Card>;
};

export default NetDevs;
